<p-toast></p-toast>
<p-blockUI [blocked]="isLoading">
    <div class="fixed top-0 left-0 w-full h-full flex align-items-center justify-content-center z-5"
        style="background: rgba(0,0,0,0.3);">
        <i class="pi pi-spinner pi-spin" style="font-size: 2rem; color: #000"></i>
    </div>
</p-blockUI>



<div [formGroup]="parentForm">
    <div formArrayName="recommendations">
        <div *ngFor="let rec of recommendationsForm.controls; let i = index" [formGroupName]="i" class="rec-card mb-4">

            <!-- Card header -->
            <div class="rec-card-title-row">
                <span class="rec-card-title">{{ getOrdinal(i + 1) }} Recommendation</span>
                <button pButton type="button" icon="pi pi-trash"
                    class="p-button-danger p-button-text p-button-sm"
                    style="color: #ef4444; background: transparent; border: none; font-size: 1.2rem; cursor: pointer;" 
                    (click)="removeRecommendation(i)">
                </button>
            </div>

            <!-- Upload Banner -->
            <div class="w-full mb-2 upload-banner">
                <span class="upload-banner-text">Upload your LOR to autofill this page&nbsp;</span>
                <div class="flex align-items-center">
                    <p-fileUpload #fileUpload class="file-upload-button1" *ngIf="!hasFiles(i)" mode="basic"
                        chooseLabel="Upload file" chooseIcon="pi pi-upload" [auto]="true"
                        (onSelect)="onFileUpload($event, i, fileUpload)" styleClass="file-upload-btn">
                    </p-fileUpload>
                    <div *ngIf="hasFiles(i)" class="uploaded-file-pill flex align-items-center gap-2">
                        <i class="pi pi-file upload-file-icon"></i>
                        <span class="uploaded-file-name cursor-pointer" (click)="openPreview(getUploadedFiles(i)[0])">{{
                            getDocumentDisplayName(i) }}</span>
                        <button pButton type="button" icon="pi pi-times"
                            class="p-button-rounded p-button-danger p-button-text uploaded-file-remove"
                            (click)="removeFileObj(i)"></button>
                    </div>
                </div>
                </div>
                <small class="p-error block mt-2 mb-2" *ngIf="rec.get('lorFiles')?.hasError('required') && rec.get('lorFiles')?.touched">LOR is required</small>

            <!-- Fields 2-col -->
            <div class="rec-field-grid">
                <div class="rec-field-group">
                    <label class="rec-field-label">NAME <span class="rec-required">*</span></label>
                    <input pInputText class="rec-input" formControlName="name" placeholder="Enter recommender's name"
                        [ngClass]="{'ng-invalid ng-touched': rec.get('name')?.invalid && rec.get('name')?.touched}" />
                    <small class="p-error block mt-1" *ngIf="rec.get('name')?.hasError('required') && rec.get('name')?.touched">Name
                        is required</small>
                    <small class="p-error block mt-1" *ngIf="rec.get('name')?.hasError('pattern') && rec.get('name')?.touched">Invalid format, only alphabets are allowed</small>
                </div>

                <div class="rec-field-group">
                    <label class="rec-field-label">ORGANISATION <span class="rec-required">*</span></label>
                    <input pInputText class="rec-input" formControlName="organisation"
                        placeholder="Enter name of org/school"
                        [ngClass]="{'ng-invalid ng-touched': rec.get('organisation')?.invalid && rec.get('organisation')?.touched}" />
                    <small class="p-error block mt-1"
                        *ngIf="rec.get('organisation')?.hasError('required') && rec.get('organisation')?.touched">Organisation is
                        required</small>
                    <small class="p-error block mt-1"
                        *ngIf="rec.get('organisation')?.hasError('pattern') && rec.get('organisation')?.touched">Invalid format, only alphabets are allowed</small>
                </div>

                <div class="rec-field-group">
                    <label class="rec-field-label">OFFICIAL EMAIL <span class="rec-required">*</span></label>
                    <input pInputText class="rec-input" formControlName="email" type="email"
                        placeholder="Official e-mail"
                        [ngClass]="{'ng-invalid ng-touched': rec.get('email')?.invalid && rec.get('email')?.touched}" />
                    <div *ngIf="rec.get('email')?.invalid && rec.get('email')?.touched">
                        <small class="p-error block mt-1" *ngIf="rec.get('email')?.errors?.['required']">Email is
                            required</small>
                        <small class="p-error block mt-1" *ngIf="rec.get('email')?.errors?.['email']">Invalid email
                            format</small>
                    </div>
                </div>

                <div class="rec-field-group">
                    <label class="rec-field-label">CONTACT NUMBER <span class="rec-required">*</span></label>
                    <input pInputText class="rec-input" formControlName="contact" placeholder="Phone Number" inputmode="numeric" maxlength="10"
                        [ngClass]="{'ng-invalid ng-touched': rec.get('contact')?.invalid && rec.get('contact')?.touched}" />
                    <div *ngIf="rec.get('contact')?.invalid && rec.get('contact')?.touched">
                        <small class="p-error block mt-1" *ngIf="rec.get('contact')?.errors?.['required']">Contact number is required</small>
                        <small class="p-error block mt-1" *ngIf="rec.get('contact')?.errors?.['pattern']">Enter a valid 10-digit phone number</small>
                    </div>
                </div>
            </div>
            <div class="flex flex-column align-items-end mt-3 gap-1">
                <button pButton type="button" [label]="existingIds[i] ? 'Update' : 'Save'"
                    [icon]="(savingStates[i] && savingStates[i].saving) ? 'pi pi-check' : 'pi pi-check'"
                    [disabled]="savingStates[i].saving"
                    class="p-button-sm p-button-primary border-round-lg font-semibold px-4 save-button"
                    (click)="saveEntry(i)">
                </button>
                <p class="text-xs text-red-500 m-0 p-0" *ngIf="rec.dirty">
                    You have unsaved changes. Please click {{ existingIds[i] ? 'Update' : 'Save' }} to continue.
                </p>
            </div>
        </div>
    </div>

    <!-- Add Another -->
    <div class="mt-4">
        <button pButton label="+ Add Another Recommendation" type="button" class="rec-add-btn w-full"
            (click)="addRecommendation()">
        </button>
    </div>

    <p-confirmDialog [style]="{width: '450px'}" styleClass="custom-delete-dialog"></p-confirmDialog>
</div>

<input type="file" #hiddenFileInput style="display: none;" (change)="onHiddenFileChange($event)"
    accept="image/*,application/pdf">

<p-dialog [(visible)]="displayPreviewDialog" [modal]="true" header="File Preview" [dismissableMask]="true"
    [style]="{width: 'auto', 'max-width': '90vw', 'min-width': '50vw'}">
    <div class="text-center p-4 relative" *ngIf="selectedPreviewItem" style="min-height: 250px;">
        <div *ngIf="isPreviewLoading"
            class="absolute top-0 left-0 w-full h-full flex flex-column align-items-center justify-content-center z-2 bg-white-alpha-60">
            <i class="pi pi-spinner pi-spin text-4xl text-primary mb-3"></i>
            <span class="text-600 font-medium font-bold">Loading preview...</span>
        </div>
        <img *ngIf="selectedPreviewItem?.type?.startsWith('image/')" [src]="selectedPreviewItem.previewUrl"
            style="max-width: 100%; max-height: 80vh; border-radius: 8px;" (load)="onPreviewLoad()"
            (error)="onPreviewLoad()">
        <iframe *ngIf="selectedPreviewItem?.type === 'application/pdf' && safePdfUrl" [src]="safePdfUrl" width="100%"
            height="600px" (load)="onPreviewLoad()" style="border: none; border-radius: 8px;">
        </iframe>
    </div>
</p-dialog>